<template>
  <div id="discussionSchool" class="row">
    <div class="col-12">
      <PageHeader
        :page="page"
        :has-print="readonly"
        :has-add="false"
        :has-save="false"
        :has-submit="!readonly"
        :has-return="true"
        :actions="pageActionConfig"
        @onSave="save"
        @onSubmit="onSubmit"
        @onReturn="goBack"
        @onPrint="onPrint"
      />
      <attach-discussion-document
        v-if="showAddDocument"
        title="Añadir Documentos"
        :documents="documentsToUpload"
        :pei-at-service-id="referralData?.peiAtServiceId"
        :readonly="showSeeDocumentsButton"
        :is-signed-pending="isDeliveredSignaturePendingStatus"
        :student-sie="referralData?.studentSieId"
        @on-cancel-add-document="showAddDocument = false"
        @on-save-document="onSaveDocument($event)"
        @on-delete-document="onDeleteDocument($event)"
      />
      <board :details="referralInfo" class="mb-3" />
      <div class="row">
        <div class="col-12">
          <SectionTitle
            icon="fas fa-file-user"
            content="Certificación de los Escenarios donde se utilizan los equipos de Asistencia Tecnológica"
            container-class="tag-badge-main-info my-2"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <ValidationObserver ref="discussion" v-slot="{}" tag="form">
            <GeneralInformation :model="model" :readonly="true" />

            <Equipments ref="equipment" :model="model" :readonly="readonly" />
          </ValidationObserver>

          <div
            v-if="isServedStatus && paramData.hasSubmittedDiscuss"
            class="my-3"
          >
            <SectionTitle has-line content="Documentos" />

            <div class="m-3">
              <div
                v-for="(item, index) in referalDocuments"
                :key="index"
                class="row py-2 mr-md-0 align-items-center bg-gray my-4 py-4  custom-border"
              >
                <div class="col-md-5 col-12 mt-3 mt-md-0">
                  <div class="color-gray-6 font-14">Tipo de Documento:</div>
                  <div class="color-black font-16">
                    {{ item?.documentName }}
                  </div>
                </div>
                <div class="col-md-5 col-12 mt-3 mt-md-0">
                  <div class="color-gray-6 font-14">Archivo:</div>
                  <div class="color-black font-16">
                    {{ item?.documentTitle }}
                  </div>
                </div>
                <div
                  class="col mt-3 mt-md-0 d-flex justify-content-end align-items-center"
                >
                  <action-button
                    text="Descargar"
                    class="btn-action-size ml-2"
                    i="fas fa-file-download"
                    variant="success"
                    @click="onDownloadDocument(item?.documentTypeId)"
                  />
                </div>
              </div>
              <div
                class="row py-2 mr-md-0 align-items-center bg-gray my-4  py-4 custom-border"
              >
                <div class="col-md col-12 mt-3 mt-md-0">
                  <div class="color-gray-6 font-14">Tipo de Documento:</div>
                  <div class="color-black font-16">
                    PEI firmado
                  </div>
                </div>
                <div v-if="hasSignedPei" class="col-md-5 col-12 mt-3 mt-md-0">
                  <div class="color-gray-6 font-14">Archivo:</div>
                  <div class="color-black font-16">
                    PEI.pdf
                  </div>
                </div>
                <div
                  v-if="hasSignedPei"
                  class="col-md-2 col-12 mt-3 mt-md-0 d-flex justify-content-end align-items-center"
                >
                  <action-button
                    text="Descargar"
                    class="btn-action-size ml-2"
                    i="fas fa-file-download"
                    variant="success"
                    @click="getSignedPeiDocument"
                  />
                </div>
                <div
                  v-if="!hasSignedPei"
                  class="col-md-9 col-12 mt-3 mt-md-0 d-flex justify-content-center align-items-center"
                >
                  <WarningBox
                    class="w-100"
                    title="Para obtener el documento de PEI firmado debe dirigirse a la enmienda de PEI creada en estatus completado para llevarlo a Firmado"
                  >
                    <a class="link" @click="goToStudentPeiHistory">
                      . Ir al PEI.
                    </a>
                  </WarningBox>
                </div>
              </div>
            </div>
          </div>

          <SectionTitle has-line content="Firma de Participantes" />
          <Tab9ParticipantSignatures
            ref="participantSignatures"
            :key="componentKey"
            :value="signatureList"
            :options="availableSignatureOptions"
            :participation-types="participationTypeList"
            :alternate-participations="alternateParticipationTypeList"
            :is-draft="!readonly"
            :fullname-only="false"
            :info-message="signatureInfoMessage"
            @addSignature="addSignature()"
            @deleteSignature="deleteSignature"
          />
        </div>
      </div>
      <div class="col-12 p-0 d-flex justify-content-end align-items-center">
        <ActionButton
          i="fas fa-arrow-circle-left"
          variant="custom-btn-return m-2"
          @click="goBack"
        >
          Regresar
        </ActionButton>
        <ActionButton
          v-if="readonly"
          variant="custom-btn-return m-2 ml-4"
          :i="`fas fa-print pr-1`"
          @click="onPrint"
        >
          Imprimir
        </ActionButton>
      </div>
    </div>
  </div>
</template>

<script>
import GeneralInformation from './GeneralInformation';
import Equipments from './DiscussionEquipment';
import { ValidationObserver } from 'vee-validate';
import { SectionTitle } from '@/components/pei/shared';
import mixAlert from '@/mixin/alert.mixin';
import mixWait from '@/mixin/loading.mixin';
import store from '@/store/index';
import { attendanceArea } from '@/utils/constants/at/attendanceArea';
import { attendanceGroup } from '@/utils/constants/at/attendanceGroup';
import generalService from '@/services/pei/general';
import PageHeader from '@/components/common/page/PageHeader';
import { ActionButton } from '@/components/common';
import Board from 'Board';
import AttachDiscussionDocument from '@/components/at/evaluationdiscussionAT/components/AttachDiscussionDocument';
import atService from '@/services/pei/at';
import objectToFormData from 'object-to-formdata';
import DocumentsService from '@/services/documents';
import { peiAtServiceStatus } from '@/utils/constants/at/peiAtServiceStatus';
import signatureService from '@/modules/common/signature.api';
import RegistrationDocumentsInformation from '../../../views/student/referralPartCToPartB/components/online-registration/RegistrationDocumentsInformation.vue';
import Tab9ParticipantSignatures from '@/components/pei/tabs/components/Tab9/participantSignatures/Tab9ParticipantSignatures';
import WarningBox from '@/components/pei/service/components/ServiceWarningBox';
import studentService from '@/services/student';

const equipmentDocumentTypes = {
  MINUTADISCUSIONEVALUACION: 16,
  ESTIPULACION80: 18,
  MINUTA: 19,
};

export default {
  name: 'ReferralATDiscussionSchool',
  mixins: [mixAlert, mixWait],
  components: {
    GeneralInformation,
    Equipments,

    ValidationObserver,
    SectionTitle,
    Tab9ParticipantSignatures,
    PageHeader,
    ActionButton,
    Board,
    AttachDiscussionDocument,
    RegistrationDocumentsInformation,
    WarningBox,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-edit',
        title: 'Discusión Equipo AT en Escuela',
        routes: ['Inicio', 'PEI', 'Discusión Equipo AT en Escuela'],
      },
      readonly: false,
      errorMessage: '',
      peiAT: store.getters.SelectedAt,
      paramData: sessionStorage.getItem('ReferralData')
        ? JSON.parse(sessionStorage.getItem('ReferralData'))
        : null,
      model: {
        peiAtServiceId: null,
        completedFlag: false,
        date: null,
        equipments: [],
        participants: [],
      },
      signatures: [],
      alternateParticipationTypeList: [],
      participationTypeList: [],
      signatureList: [],
      availableSignatureOptions: [],
      componentKey: 0,
      signatureCounter: 0,
      signatureInfoMessage: '',
      validateComponent: false,

      saved: false,
      isValid: false,
      stickyButtons: {
        type: Boolean,
        Default: false,
      },
      places: [
        { signatureGroupId: attendanceGroup.GrupoDeEncargados },
        {
          signatureGroupId:
            attendanceGroup.TercerGrupoFirmasCambioImpedimentoRazonesEspecificas,
        },
        {
          signatureGroupId:
            attendanceGroup.SegundoGrupoFirmasCambioImpedimentoEvaluacionTrianual,
        },
      ],
      attendanceArea: attendanceArea.CambioImpedimentoEvaluaciónTrianual,
      getParticipantSignatures: true,
      referralData: {},
      showAddDocument: false,
      showSeeDocumentsButton: false,
      documentsToUpload: [
        {
          documentTypeId: equipmentDocumentTypes.ESTIPULACION80,
          documentTitle: 'Estipulación Minuta 80',
          required: false,
          disabled: false,
          document: null,
          filename: '',
        },
        {
          documentTypeId: equipmentDocumentTypes.MINUTA,
          documentTitle: 'Minuta de Entrega de Equipo Firmada',
          required: false,
          disabled: false,
          document: null,
          filename: '',
        },
      ],
      hasIncomplete: false,
      signedPeiDocumentId: null,
      referalDocuments: [],
      student: null,
    };
  },
  created() {
    this.loadValidationMessages();
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  computed: {
    referralInfo() {
      return [
        [
          {
            label: 'Número de Referido:',
            data: this.referralData?.referralNumber,
            icon: 'fas fa-ballot-check',
          },
          {
            label: 'Estatus:',
            data: this.referralData?.serviceStatusName,
            icon: 'fas fa-ballot-check',
          },
          {
            label: 'Fecha Referido:',
            data: this.$options.filters.date(this.referralData?.referralDate),
            icon: 'fas fa-calendar-edit',
          },
          {
            label: 'CAAT:',
            data: this.referralData?.caatName,
            icon: 'fas fa-ballot-check',
          },
          {
            label: 'Estudiante/Solicitante:',
            data: `${this.referralData?.studentSieId} - ${this.referralData?.studentName}`,
            icon: 'fas fa-address-book',
          },
        ],
      ];
    },
    showAlertMessage() {
      return [
        peiAtServiceStatus.PendienteDeDiscusion,
        peiAtServiceStatus.PendienteDeDiscusionEscuela,
        peiAtServiceStatus.EntregadoPendienteFirma,
      ].includes(this.referralData.serviceStatusId);
    },
    isDiscussedSignPendingStatus() {
      return (
        this.referralData.serviceStatusId ==
        peiAtServiceStatus.EntregadoPendienteFirma
      );
    },
    pageActionConfig() {
      return [
        {
          text: 'Anejar Documento',
          icon: 'fas fa-file-alt',
          variant: 'success',
          visible:
            this.readonly &&
            [
              peiAtServiceStatus.PendienteDeDiscusionEscuela,
              peiAtServiceStatus.EntregadoPendienteFirma,
            ].includes(this.referralData.serviceStatusId) &&
            !this.showAddDocument &&
            !this.showSeeDocumentsButton,
          click: () => this.onAddDocument(),
        },
        {
          text: 'Ver Documentos',
          icon: 'fas fa-file-download',
          variant: 'outline-success',
          visible: this.showSeeDocumentsButton,
          click: () => this.onAddDocument(),
        },
      ];
    },
    isDeliveredSignaturePendingStatus() {
      return (
        this.referralData.serviceStatusId ==
        peiAtServiceStatus.EntregadoPendienteFirma
      );
    },
    isServedStatus() {
      return this.referralData.serviceStatusId == peiAtServiceStatus.Servido;
    },
    hasSignedPei() {
      return Boolean(this.signedPeiDocumentId);
    },
  },
  async mounted() {
    if (!!this.$route.params.referralId) {
      this.$store.dispatch('setSelectedAt', this.$route.params.referralId);
      await this.getReferralSimpleData(this.$route.params.referralId);
    }

    this.referralData = this.paramData;
    await this.initData();
    await this.getStudent();
  },
  methods: {
    async initData() {
      await this.getAvailableSignatureOptions();
      await this.getParticipationTypeList();
      await signatureService
        .getAlternateParticipationTypeList()
        .then((result) => {
          this.alternateParticipationTypeList = result.data;
        });
      this.getEvaluation();
      await this.validatePeiSigned();
      await this.getDocumentAttachments();
    },
    getSignedPeiDocument() {
      DocumentsService.downloadFromServer(this.signedPeiDocumentId);
    },
    onDownloadDocument(documentTypeId) {
      generalService.documentsDownloadFiles(
        this.referralData.peiAtServiceId,
        documentTypeId
      );
    },
    async getDocumentAttachments() {
      const { data } = await atService.getDocumentAttachments(
        this.referralData.peiAtServiceId
      );
      this.referalDocuments = data.filter((x) =>
        [
          equipmentDocumentTypes.ESTIPULACION80,
          equipmentDocumentTypes.MINUTA,
        ].includes(x.documentTypeId)
      );
    },
    async validatePeiSigned() {
      const { data } = await generalService.getAtLastSignedPeiDocument(
        this.referralData.peiAtServiceId
      );
      this.signedPeiDocumentId = data;
    },
    goBack() {
      this.$router.go(-1);
    },
    loadValidationMessages() {
      const messageCodes = ['0675', '191358', '0636'];
      const promise = this.$ApiGet(
        '/api/validationsmessages?messageCodes=' +
          messageCodes.join('&messageCodes=')
      );
      promise.then((res) => {
        this.validationMessages = res.data;
      });
    },
    getMessage(code) {
      const message = this.validationMessages.find(
        (element) => element.id == code
      );
      return message;
    },
    async getParticipationTypeList() {
      await signatureService
        .getParticipationTypeList()
        .then((res) => {
          this.participationTypeList = res.data;
        })
        .catch((err) => {
          this.response = err;
        });
    },
    async setSignatureConfig() {
      let signatureConfig = [];
      await signatureService
        .getDefaultConfiguration(null, this.referralData?.studentSieId)
        .then((result) => {
          signatureConfig = result.data;
        });
      this.signatureList = [];

      if (!this.readonly) {
        if (signatureConfig.length > 0) {
          this.signatureInfoMessage = signatureConfig.find(
            (e) => e.name != ''
          )?.name;

          signatureConfig.forEach((config) => {
            let options = {
              readonly: this.readonly,
              signatureCounter: this.signatureCounter,
              isDraft: this.readonly,
            };

            let signature = signatureService.getBasicSignature(
              this.availableSignatureOptions,
              this.model.participants,
              options,
              config.id,
              config.value
            );

            if (signature != undefined) {
              this.signatureList.push(signature);
              this.signatureCounter -= 1;
            }
          });
        } else {
          let options = {
            readonly: this.readonly,
            signatureCounter: this.signatureCounter,
            isDraft: this.readonly,
          };

          let signature1 = signatureService.getBasicSignature(
            this.availableSignatureOptions,
            this.model.participants,
            options,
            1
          );
          if (signature1 != undefined) {
            this.signatureList.push(signature1);
            this.signatureCounter -= 1;
          }
          let signature5 = signatureService.getBasicSignature(
            this.availableSignatureOptions,
            this.model.participants,
            options,
            5
          );
          if (signature5 != undefined) {
            this.signatureList.push(signature5);
            this.signatureCounter -= 1;
          }

          let signature6 = signatureService.getBasicSignature(
            this.availableSignatureOptions,
            this.model.participants,
            options,
            4
          );
          if (signature6 != undefined) {
            this.signatureList.push(signature6);
            this.signatureCounter -= 1;
          }
        }
      }

      this.loadSignatures();
    },
    async getAvailableSignatureOptions() {
      await signatureService.getAvailableSignatureOptions().then((res) => {
        this.availableSignatureOptions = res.data;
      });
    },
    loadSignatures() {
      let self = this;

      this.model.participants.forEach(function(data) {
        self.signatureList.push({
          id: data.id,
          signature: {
            name: data.fullName,
            positionId: { signaturePositionId: data.position.id },
            participationId: { id: Number(data.participationType) },
            alternateId: { id: data.alternateParticipationType },
          },
          groupId: 0,
          isRequired: self.ValidationTriggered.validation,

          isRemovable: data.isEvaluationAccepted ? false : true,
          isDisabled: !self.isDraft ? true : false,
          nameDisabled: data.isEvaluationAccepted ? true : false,
          participationDisabled: data.isEvaluationAccepted ? true : false,
          positionDisabled: data.isEvaluationAccepted ? true : false,
          isDraft: self.isDraft,
        });
      });
    },
    ValidationTriggered() {
      return store.getters.getPeiValidationTriggered;
    },
    addSignature() {
      this.signatureCounter -= 1;
      this.signatureList.push({
        id: this.signatureCounter,
        signature: {
          name: '',
          positionId: undefined,
          participationId: undefined,
          alternateId: undefined,
        },
        groupId: 0,
        isRequired: this.validateComponent,
        isRemovable: true,
        isDisabled: false,
      });
    },

    deleteSignature(id) {
      let signatureListIndex = this.signatureList.findIndex((e) => e.id === id);
      this.signatureList.splice(signatureListIndex, 1);
    },
    getEvaluation() {
      this.$ApiGet(
        'api/atservice/referralatdiscussionschool?peiatserviceid=' + this.peiAT
      )
        .then(async (response) => {
          const data = response.data;
          data.equipments = this.formatDataEquipments(data.equipments);
          this.model = data;
          this.setSignatureConfig();
          if (this.model.stipulation80Signed != null) {
            let stipulation80SignedDocument = this.documentsToUpload.find(
              (c) => c.documentTypeId == equipmentDocumentTypes.ESTIPULACION80
            );
            stipulation80SignedDocument.disabled = true;
            stipulation80SignedDocument.document = this.model.stipulation80Signed;
            stipulation80SignedDocument.canDelete = this.canDeleteDocument();
          }

          if (this.model.minuteEquipDeliverySigned != null) {
            let minuteEquipDeliverySignedDocument = this.documentsToUpload.find(
              (c) => c.documentTypeId == equipmentDocumentTypes.MINUTA
            );
            minuteEquipDeliverySignedDocument.disabled = true;
            minuteEquipDeliverySignedDocument.document = this.model.minuteEquipDeliverySigned;
            minuteEquipDeliverySignedDocument.canDelete = this.canDeleteDocument();
          }

          if (
            this.model.stipulation80Signed != null &&
            this.model.minuteEquipDeliverySigned != null
          )
            this.showSeeDocumentsButton = true;

          this.model.date = new Date(this.model.date);
          if (this.model.completedFlag) {
            this.signatures = this.model.participants.map((p) => ({
              name: p.fullName,
              positionId: p.position.id,
              isDisabled: true,
            }));

            this.componentKey = 1;
            this.readonly = true;
          }
        })
        .catch((err) => {
          this.response = err;
        });
    },
    canDeleteDocument() {
      return [
        peiAtServiceStatus.PendienteDeDiscusionEscuela,
        peiAtServiceStatus.EntregadoPendienteFirma,
      ].includes(this.referralData.serviceStatusId);
    },
    validateSignatures(data) {
      let isValid = true;
      let errorMsgs = 'Información incompleta. (190803)';

      if (data.participationId?.id == 2 && !data.alternateId) {
        this.ShowToast('', errorMsgs, 'error');
        isValid = false;
      }

      if (!data.name || !data.participationId?.id || !data.positionId) {
        this.ShowToast('', errorMsgs, 'error');
        isValid = false;
      }
      return isValid;
    },
    async onSubmit() {
      if (this.showAlertMessage) {
        let isConfirmed = await this.ShowCancelModal(
          'Confirmación',
          'Al someter este proceso se estará creando una copia del PEI en estatus Completado con las firmas documentadas.<br><b> ¿Está seguro que desea someter la discusión de escuela? </b> ',
          'Si',
          'No'
        );

        if (!isConfirmed) return;
      }

      let isValid = await this.$refs.discussion.validate();
      this.validateComponent = true;

      if (this.signatureList.length == 0) {
        this.ShowToast(
          'Alerta',
          'Debe contener las firmas correspodientes',
          'error'
        );
        isValid = false;
      } else {
        this.signatureList.map((x) => (x.isRequired = this.validateComponent));
      }

      const areEquipmentUsesNotDefined = this.model.equipments.some((e) => {
        return e.areEquipmentSchoolDefined === false;
      });

      if (areEquipmentUsesNotDefined) {
        this.ShowToast('Alerta', this.getMessage('191358').name, 'error');
        isValid = false;
      }

      if (!isValid) {
        return;
      }

      this.$refs.participantSignatures.value.forEach((s) => {
        this.validateSignatures(s.signature);
        this.validateSignatures(s.signature);
        if (this.validateSignatures(s.signature) == false) {
          this.hasIncomplete = true;
        } else {
          this.hasIncomplete = false;
        }
        this.model.participants.push({
          id: s.id,
          name: s.signature.name,
          lastName: s.signature.paternalName,
          secondLastName: s.signature.maternalName,
          participationType: s.signature.participationId?.id,
          alternateParticipationType: s.signature.alternateId
            ? s.signature.alternateId.id
            : undefined,
          position: {
            id: s.signature.positionId
              ? s.signature.positionId.signaturePositionId
              : undefined,
          },
        });
      });
      if (!this.hasIncomplete) {
        this.save();
      }
    },
    formatDataEquipments(data) {
      const rows = [];

      data.forEach((element) => {
        const row = {
          id: element.id,
          areEquipmentSchoolDefined: false,
          placeholder: '',
          rules: '',
          recommendation: {
            id: element.recommendation.id,
            equipmentName: element.recommendation.equipmentName,
            usedAtHome: element.recommendation.usedAtHome,
            usedInSchool: element.recommendation.usedInSchool,
            usedInTherapy: element.recommendation.usedInTherapy,
            usedInOthers: element.recommendation.usedInOthers,
            usedInOtherDescription:
              element.recommendation.usedInOtherDescription,
            schoolUsedAtHome: element.recommendation.schoolUsedAtHome,
            schoolUsedInSchool: element.recommendation.schoolUsedInSchool,
            schoolUsedInTherapy: element.recommendation.schoolUsedInTherapy,
            reason: element.recommendation.reason,
          },
        };
        rows.push(row);
      });
      return rows;
    },
    save() {
      this.$ApiPost('api/atservice/discussionstipulation80/save', this.model)
        .then(() => {
          this.readonly = true;
          this.$refs.participantSignatures.value.forEach((s) => {
            s.isDisabled = true;
          });

          this.ShowToast(
            'Proceso exitoso.',
            this.getMessage('0636').name,
            'success'
          );
        })
        .then(() =>
          this.getReferralSimpleData(this.referralData.peiAtServiceId)
        )
        .then(() => this.initData())
        .catch((err) => {
          this.response = err;
        });
    },
    handleScroll() {
      if (window.scrollY > 200) {
        this.stickyButtons = true;
      } else {
        this.stickyButtons = false;
      }
    },
    onPrint() {
      const self = this;

      const promise = new Promise((resolve) => {
        self
          .$ApiGet('/api/report/stipulation80/' + this.peiAT)
          .then((res) => {
            self.report = res.data;
            generalService.documentDownloadReport(
              self.report.content,
              self.report.filename
            );
            resolve(res.data);
          })
          .catch((err) => {
            self.response = err;
          });
      });
      return promise;
    },
    onAddDocument() {
      this.showAddDocument = !this.showAddDocument;
    },
    async onSaveDocument(documents) {
      let stipulation80 = null;
      let minute = null;

      documents.forEach((value) => {
        if (
          value.documentTypeId == equipmentDocumentTypes.ESTIPULACION80 &&
          value.document &&
          !value.disabled
        )
          stipulation80 = value.document;

        if (
          value.documentTypeId == equipmentDocumentTypes.MINUTA &&
          value.document &&
          !value.disabled
        )
          minute = value.document;
      });

      if (
        peiAtServiceStatus.EntregadoPendienteFirma ==
          this.referralData.serviceStatusId &&
        (!documents.some(
          (value) =>
            value.documentTypeId == equipmentDocumentTypes.ESTIPULACION80 &&
            value.document
        ) ||
          !documents.some(
            (value) =>
              value.documentTypeId == equipmentDocumentTypes.MINUTA &&
              value.document
          ))
      ) {
        this.ShowToast('Alerta', 'Debe anejar ambos documentos.', 'error');
        return;
      }

      if (stipulation80 == null && minute == null) {
        this.ShowToast(
          'Alerta',
          'Debe al menos anejar (1) documento.',
          'error'
        );
        return;
      }

      let formData = objectToFormData(
        {
          peiAtServiceId: this.referralData.peiAtServiceId,
          peiAtServiceCurrentStatusId: this.referralData.serviceStatusId,
        },
        { indices: true }
      );

      formData.append('minute', minute);
      formData.append('stipulation80', stipulation80);

      await atService
        .schoolDiscussionUploadDocument(
          this.referralData.peiAtServiceId,
          formData
        )
        .then((response) => {
          this.ShowToast(
            'Proceso Exitoso.',
            'El documento ha sido anejado exitosamente.',
            'success'
          );
          this.showAddDocument = false;
          if (response.data) {
            this.referralData.serviceStatusId = response.data.serviceStatusId;
            this.referralData.serviceStatusName =
              response.data.serviceStatusName;
          }

          this.getEvaluation();
        });
    },
    downloadDocument(document) {
      DocumentsService.Download(document);
    },
    async onDeleteDocument(documentTypeId) {
      await atService
        .deleteDocument(this.referralData.peiAtServiceId, documentTypeId)
        .then(() => {
          this.ShowToast(
            'Proceso Exitoso.',
            'El documento ha sido eliminado exitosamente.',
            'success'
          );
          this.documentsToUpload.map((x) => {
            x.document = null;
            x.disabled = false;
            return x;
          });
          this.getEvaluation();
        });
    },
    async getReferralSimpleData(peiAtServiceId) {
      const { data } = await atService.getPeiAtServiceSimpleData(
        peiAtServiceId
      );

      if (data) {
        sessionStorage.setItem('ReferralData', JSON.stringify(data));
        this.referralData = data;
      }
    },
    async goToStudentPeiHistory() {
      await this.$store.dispatch('$_student/setStudentDetails', {
        student: this.student,
        studentId: this.student.studentId,
        viewStudentInfo: true,
        selectThisStudent: true,
      });
      this.$store.commit('$_student/showStudentBox', true);
      this.$router.push({
        name: 'studentHistory',
      });
    },
    async getStudent() {
      const { data: response } = await studentService.getBySie(
        this.paramData.studentSieId,
        false
      );
      this.student = response;
    },
  },
};
</script>

<style scoped>
.top-bottom {
  padding-top: 55px;
}
.w-defined {
  display: flex;
  flex-direction: row-reverse;
}

.sticky-bottom-right {
  position: fixed;
  bottom: 50px;
  right: 50px;
  z-index: 1;
}

.section-bottom-spacing {
  margin-bottom: 50px !important;
}

.section-left-spacing {
  margin-left: 10px;
}

.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.panel-gray {
  background-color: #f8f9fa;
}

.input-group .hidden {
  display: none;
}
.input-group .entry {
  height: 25px;
  position: relative;
  width: 110px;
}
.input-group .circle {
  border: 1px solid #e2e2e2;
  border-radius: 50%;
  cursor: pointer;
  height: 20px;
  position: absolute;
  transition: border-color 300ms;
  width: 20px;
}
.input-group .entry-label {
  cursor: pointer;
  font-weight: 800;
  margin-top: -3px;
  padding-left: 30px;
  user-select: none;
  -moz-user-select: none;
}
.input-group .highlight {
  background: #2db782;
  border-radius: 50%;
  height: 10px;
  left: 5px;
  pointer-events: none;
  position: absolute;
  top: 5px;
  transition: transform 400ms cubic-bezier(0.175, 0.885, 0.32, 1.2);
  transform: translateX(0px);
  width: 10px;
}
.input-group .hidden:nth-child(1):checked ~ .highlight {
  transform: translateY(0);
}
.input-group .hidden:nth-child(3):checked ~ .highlight {
  transform: translateX(110px);
}
.input-group .hidden:nth-child(1):checked + .entry .circle {
  border-color: #e2e2e2;
}
.custom-btn-return {
  border: 1px solid #2db782;
  color: #2db782;
}

.custom-btn-return:hover {
  background-color: #2db782;
  border: 1px solid #2db782;
  color: #fff;
}

#discussionSchool >>> .content-table-striped th {
  padding: 1.2rem 0rem 1.2rem 1rem !important;
}
#discussionSchool >>> #signatures span[name='participants'] tr {
  background: none !important;
  padding-left: 15px;
  border-bottom: 1px solid #dee2e6;
}
#discussionSchool >>> #signatures span[name='participants'] tr > td {
  border: 0;
  border-bottom: 0px;
  padding-left: 15px;
}
#discussionSchool >>> #signatures span[name='participants'] tr td {
  padding-left: 0px;
}
#discussionSchool
  >>> #signatures
  span[name='participants']
  tr
  td
  .vs__dropdown-toggle {
  padding-left: 0px;
  height: 38px;
}
.custom-border {
  border-left: solid 4px #b5c3bc;
  border-radius: 4px;
}
/* vs__dropdown-toggle */
</style>
<style scoped src="@/assets/css/component/panel-simple.css"></style>
